import script from "./base-product-list.vue?vue&type=script&setup=true&lang=js"
export * from "./base-product-list.vue?vue&type=script&setup=true&lang=js"

import "./base-product-list.vue?vue&type=style&index=0&id=447ce5f8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447ce5f8"]])

export default __exports__